import Vue from "vue";
import VueChatScroll from "vue-chat-scroll";
import VBodyScrollLock from "v-body-scroll-lock";
import Vue2TouchEvents from "vue2-touch-events";
import App from "./App.vue";
// import "./registerServiceWorker";
import router from "./router";
import store from "./store";
import * as Sentry from "@sentry/vue";
import { BrowserTracing } from "@sentry/tracing";

Vue.config.productionTip = false;
Vue.use(VueChatScroll);
Vue.use(VBodyScrollLock);
Vue.use(Vue2TouchEvents, {
  swipeTolerance: 150
});

Sentry.init({
  Vue,
  dsn: "https://134a6c316ead4be0b8f08dc449f3790d@o4503969996996608.ingest.sentry.io/4503970002698240",
  integrations: [
    new BrowserTracing({
      routingInstrumentation: Sentry.vueRouterInstrumentation(router),
      tracingOrigins: ["localhost", "https://akanfesten.no/", /^\//],
    }),
  ],
  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: 1.0,
  logErrors: true
});

// Subscribe to store updates
store.subscribe((mutation, state) => {
  // Store the state object as a JSON string
  localStorage.setItem("store", JSON.stringify(state));
});

Vue.prototype.$changePageContent = async function(hasAnswerBox) {
  const pageContent = document.querySelector(".chat-page__wrapper");
  const answerBox = document.querySelector(".answer-box");

  if (hasAnswerBox) {
    const answerBoxHeight = answerBox.offsetHeight;
    pageContent.style.paddingBottom = `${answerBoxHeight}px`;
    pageContent.scrollTop = pageContent.scrollHeight;
  } else {
    pageContent.style.paddingBottom = "40px";
  }
};

Vue.prototype.$processMessages = async function(
  messages,
  chat,
  store,
  hasVideo = false
) {
  const showNotification =
    messages.length &&
    (messages[messages.length - 1].content_type == "video" ||
      messages[messages.length - 1].type == "answer")
      ? false
      : true;

  function showMessageLoader() {
    store.dispatch("showMessageLoader", {
      chat: chat
    });
  }

  function hideMessageLoader() {
    store.dispatch("hideMessageLoader", {
      chat: chat
    });
  }

  function delay(timeout) {
    showMessageLoader();
    return new Promise(resolve =>
      setTimeout(() => {
        hideMessageLoader();
        resolve();
      }, timeout)
    );
  }

  function getRandomInt(min, max) {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min)) + min;
  }

  function calcDelayTime(obj) {
    let delayTime;

    if (obj.delay && obj.delay > 0) {
      delayTime = obj.delay * 1000;
    } else {
      if (obj.type == "message") {
        const valueLength = obj.value.length
          ? obj.value.length
          : getRandomInt(10, 100);
        const avgTypingTime = valueLength * 50;
        delayTime = Math.min(Math.max(avgTypingTime, 800), 2250);
      } else {
        delayTime = 750;
      }
    }

    return delayTime;
  }

  async function showMessage(obj, chat, store) {
    await store.dispatch("toggleMessageType", {
      message: obj,
      textMessage: obj.value
    });

    if (chat.script.length > 1 ||
      (chat.script.length == 1 && chat.script[0].type !== 'chapter-end' && chat.script[0].type !== 'chapter-end-same-chat')
    ) {
      const delayTime = calcDelayTime(obj);
      await delay(delayTime);
    }

    await store.dispatch("removeItemFromScript", {
      chat: chat
    });

    if (obj.type != "answer") {
      store.dispatch("insertMessage", {
        chat: chat,
        object: JSON.parse(JSON.stringify(obj)),
        showNotification: showNotification
      });
    }
  }

  async function showAnswer(obj, chat, store) {
    store.dispatch("showAnswer", {
      chat: chat,
      value: obj
    });
  }

  if (messages[0]) {
    if (messages[0].type != "answer") {
      if (messages[0].content_type == "video") {
        await showMessage(messages[0], chat, store);
        return false;
      }

      await showMessage(messages[0], chat, store);

      if (messages.length > 0) {
        if (messages[0].content_type == "video") {
          if (!hasVideo) {
            this.$processMessages(messages, chat, store, true);
          }
          return false;
        }

        if (!hasVideo) {
          this.$processMessages(messages, chat, store, false);
        }

        return false;
      }
    } else {
      await showAnswer(messages[0], chat, store);
      hideMessageLoader();
      return false;
    }
  }
};

window.Event = new (class {
  constructor() {
    this.vue = new Vue();
  }
  fire(event, data = null) {
    this.vue.$emit(event, data);
  }
  listen(event, callback) {
    this.vue.$on(event, callback);
  }
})();

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
